'use strict';

module.exports = {
  outputDir: '../../../wwwroot/spa',
  backend: '',
  themeName: process.env.THEME_NAME,
  apiPrefixes: {
    v1: 'api/v1',
    v2: 'api/v2',
  },

  dev: {
    publicPath: '/',
    port: 8080,
  },

  build: {
    publicPath: '/spa/',
  },
};
